<template>
  <UlDialog
    v-model="dialog"
    header-type="information"
    :persistent="deleted"
    :left-header-icon="`icons/${deleted ? 'check_circle' : 'stop'}.svg`"
    :title="dialogTitle"
    :buttons="accountDeleteButtons"
    @input="handleDialogInput"
  >
    <template #text>
      <AccountDeleteForm
        v-if="dialog"
        @buttons-change="accountDeleteButtons = $event"
        @state-change="handleStateChange"
        @close="close"
        @logout="handleLogout"
      />
    </template>
  </UlDialog>
</template>

<script>
export default {
  name: 'AccountDeleteDialog',
  components: {
    AccountDeleteForm: () => import('@/feature/account-delete/components/AccountDeleteForm.vue')
  },
  data() {
    return {
      accountDeleteButtons: [],
      stepName: 'confirm',
      deleted: false
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'accountDelete';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    },
    dialogTitle() {
      if (this.deleted) {
        return this.$t('profile.removeDialog.confirmTitle');
      }

      switch (this.stepName) {
        case 'confirm':
          return this.$t('profile.removeDialog.areYouSure.title');
        case 'feedback':
          return this.$t('profile.removeDialog.feedback.title');
        case 'password':
          return this.$t('profile.removeDialog.password.title');
        default:
          return this.$t('profile.removeDialog.title');
      }
    }
  },
  methods: {
    handleStateChange({ stepName, deleted }) {
      this.stepName = stepName;
      this.deleted = deleted;
    },
    close() {
      this.dialog = false;
    },
    async handleLogout() {
      await this.logout();
      this.close();
    },
    handleDialogInput(value) {
      if (!value) {
        this.close();
      }
    }
  }
};
</script>
